import { Navigate } from "react-router-dom";

import { getStorageSync } from "@modules/storage/storageHelper";
import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";

export const requireAutoAuth = (Children: JSX.Element) => {
  const RenderChildren = () => {
    const forceAuthenticate = getQueryFromUrl("forceAuthenticate");

    const autoAuthenticated = getStorageSync("AUTO_AUTHENTICATED");

    return autoAuthenticated && forceAuthenticate === "false" ? (
      <Navigate to={"/"} />
    ) : (
      Children
    );
  };

  return <RenderChildren />;
};
